export default __webpack_public_path__ + "static/media/geogebra.c99474bd.png";